/**
 * useTitle Hook
 * Sets the document title for SEO and browser tab display
 */

import { useEffect } from 'react';

const APP_NAME = 'WBB Portal';

/**
 * Custom hook to set the page title
 * @param title - The page-specific title
 * @param showAppName - Whether to append the app name (default: true)
 */
export const useTitle = (title: string, showAppName: boolean = true): void => {
  useEffect(() => {
    const previousTitle = document.title;
    
    document.title = showAppName && title 
      ? `${title} — ${APP_NAME}`
      : title || APP_NAME;

    // Restore previous title on unmount (optional behavior)
    return () => {
      document.title = previousTitle;
    };
  }, [title, showAppName]);
};

/**
 * Page titles mapping for consistency
 */
export const PAGE_TITLES = {
  LOGIN: 'Masuk',
  STATEMENT_RECORDER: 'Saldo Bank/Kas Harian',
  MUTUAL_FUND_RECORDER: 'Saldo Reksadana Harian',
  DASHBOARD: 'Dashboard',
  ANALYTICS: 'Analitik',
  SETTINGS: 'Pengaturan Sistem',
  SETTINGS_COMPANIES: 'Kelola Perusahaan',
  SETTINGS_USERS: 'Kelola Pengguna',
  // Legacy aliases
  ADMIN_DASHBOARD: 'Dashboard',
  ADMIN_OVERVIEW: 'Dashboard',
  ADMIN_COMPANIES: 'Kelola Perusahaan',
  ADMIN_USERS: 'Kelola Pengguna',
  ADMIN_ANALYTICS: 'Analitik',
  USER_MANAGER: 'Kelola Pengguna',
  COMPANY_MANAGER: 'Kelola Perusahaan',
  NOT_FOUND: 'Halaman Tidak Ditemukan',
} as const;

export default useTitle;
